import React from'react';

const GoBackLink = (props) => {
    let pageName = props.pageName;
    let pageLink = props.pageLink;

    return (
        <div id = "go-back-link"><a href={pageLink}>&lt;&nbsp;&nbsp; Back to {pageName} page</a></div>
    )
}

export default GoBackLink;